module.exports = __webpack_public_path__ + "media/images/icons/rooms/bed-1p-couch-1c6942cc0aa93e29c6d015d907f08538.svg";